import React from "react";
import styles from "./ArtworkSection.module.scss";
import ArtworkCard from "components/cards/artworkCard/ArtworkCard";
import { paintings } from "mockdata/paintings";

const ArtworkSection = () => {
  return (
    <div className={`artworksRef ${styles.artworkSectionContainer}`}>
      <div className="container">
        <div className={styles.title}>Artworks</div>
        <div className={styles.artworkList}>
          {paintings.map((painting) => {
            return <ArtworkCard item={painting} key={painting.id} />;
          })}
        </div>
        <div className={styles.loadMore}>
          <button>Load More</button>
        </div>
      </div>
    </div>
  );
};

export default ArtworkSection;
